
import React, { useMemo, useRef } from 'react';
import { Card, Badge, ListView, Flex } from 'antd-mobile';
import { Error, Loading } from '.';
import { formatDate, formatBillUnit } from "../../../utils/utils";

const dataSource = new ListView.DataSource({
  rowHasChanged: (row1, row2) => row1 !== row2,
});

function CompanyList(props) {

  const { loading, errorMessage, companyList, handleAction } = props;
  const listRef = useRef();

  const dataSourceList = useMemo(() => dataSource.cloneWithRows(companyList), [companyList])

  const row = (item) => {
    return <Card key={item.CompanyId} style={{ marginBottom: '10px' }}>
      <Card.Header
        title={item.Email || '邮箱不存在'}
        extra={<span style={{ color: '#108ee9' }} onClick={() => handleAction(item)}>操作</span>}
      />
      <Card.Body style={{ paddingBottom: '10px' }}>
        <Flex className='flex'>
          <Flex.Item className='description-title'>CompanyID</Flex.Item>
          <Flex.Item className='description-content'>{item.CompanyId || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>币种</Flex.Item>
          <Flex.Item className='description-content'>{item.Currency.toUpperCase() || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>注册地</Flex.Item>
          <Flex.Item className='description-content'>{item.RegistrationCountry || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>冻结金额</Flex.Item>
          <Flex.Item className='description-content'>{(item.Currency.toUpperCase())} {formatBillUnit(item.AmountFreeze) || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>信用额度</Flex.Item>
          <Flex.Item className='description-content'>{(item.Currency.toUpperCase())} {formatBillUnit(item.AmountCredit) || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>赠金</Flex.Item>
          <Flex.Item className='description-content'>{(item.Currency.toUpperCase())} {formatBillUnit(item.AmountFree) || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>现金余额</Flex.Item>
          <Flex.Item className='description-content'>{(item.Currency.toUpperCase())} {formatBillUnit(item.Amount) || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title'>账户可用余额</Flex.Item>
          <Flex.Item className='description-content'>{(item.Currency.toUpperCase())} {formatBillUnit(item.AmountAvailable) || '-'}</Flex.Item>
        </Flex>
        <Flex className='flex'>
          <Flex.Item className='description-title' style={{ fontWeight: 500 }}>发送统计</Flex.Item>
          <Flex.Item className='description-content'>
            <a href={`/usms/companysendstats?CompanyId=${item.CompanyId}&Email=${item.Email}`} style={{ width: '80px', fontWeight: 'bold', color: '#3498DB' }}>查看</a>
          </Flex.Item>
        </Flex>
      </Card.Body>
      <Card.Footer
        content={
          item.Upgrade === 1 ?
            <Badge text={"已升级"} style={{ backgroundColor: '#21b68a' }} /> :
            <Badge text={"未升级"} hot />}
        extra={<div style={{ marginBottom: '4px' }}>{`${formatDate(item.RegistrationTime) || '-'}`}</div>}
      />
    </Card>
  }

  return (
    <Loading loading={loading} >
      {errorMessage ?
        <Error message={errorMessage} /> : <>
          <ListView
            ref={listRef}
            initialListSize={5}
            dataSource={dataSourceList}
            renderRow={row}
            style={{
              height: '500px',
              overflowY: 'auto'
            }}
            pageSize={5}
            scrollRenderAheadDistance={200}
          />
        </>
      }
    </Loading>
  )
}

export default CompanyList